/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseSplitPanelFragment} from '@amblique/contentful/app/contentful/fragments/split-panel/base-split-panel.fragment';
import {BaseAccordionFragment} from '@amblique/contentful/app/contentful/fragments/accordion/base-accordion.fragment';
import {BaseAccordionPanelFragment} from '@amblique/contentful/app/contentful/fragments/accordion-panel/base-accordion-panel.fragment';
import {BaseCardFragment} from '@amblique/contentful/app/contentful/fragments/card/base-card.fragment';
import {BaseCarouselFragment} from '@amblique/contentful/app/contentful/fragments/carousel/base-carousel.fragment';
import {BaseEmbedPanelFragment} from '@amblique/contentful/app/contentful/fragments/embed-panel/base-embed-panel.fragment';
import {BaseHeroBannerFragment} from '@amblique/contentful/app/contentful/fragments/hero-banner/base-hero-banner.fragment';
import {BaseImageFragment} from '@amblique/contentful/app/contentful/fragments/image/base-image.fragment';
import {BaseRichTextBlockFragment} from '@amblique/contentful/app/contentful/fragments/rich-text-block/base-rich-text-block.fragment';
import {BaseSectionPanelFragment} from '@amblique/contentful/app/contentful/fragments/section-panel/base-section-panel.fragment';
import {BaseVideoFragment} from '@amblique/contentful/app/contentful/fragments/video/base-video.fragment';

export const SplitPanelFragment = gql`
  ${BaseAccordionFragment}
  ${BaseAccordionPanelFragment}
  ${BaseCardFragment}
  ${BaseCarouselFragment}
  ${BaseEmbedPanelFragment}
  ${BaseHeroBannerFragment}
  ${BaseImageFragment}
  ${BaseRichTextBlockFragment}
  ${BaseSectionPanelFragment}
  ${BaseSplitPanelFragment}
  ${BaseVideoFragment}

  fragment SplitPanelFragment on SplitPanel {
    ...BaseSplitPanelFragment

    leftContent {
      ... on Accordion {
        ...BaseAccordionFragment
      }
      ... on AccordionPanel {
        ...BaseAccordionPanelFragment
      }
      ... on Card {
        ...BaseCardFragment
      }
      ... on Carousel {
        ...BaseCarouselFragment
      }
      ... on HeroBanner {
        ...BaseHeroBannerFragment
      }
      ... on Image {
        ...BaseImageFragment
      }
      ... on RichTextBlock {
        ...BaseRichTextBlockFragment
      }
      ... on Video {
        ...BaseVideoFragment
      }
    }
    rightContent {
      ... on Accordion {
        ...BaseAccordionFragment
      }
      ... on AccordionPanel {
        ...BaseAccordionPanelFragment
      }
      ... on Card {
        ...BaseCardFragment
      }
      ... on EmbedPanel {
        ...BaseEmbedPanelFragment
      }
      ... on HeroBanner {
        ...BaseHeroBannerFragment
      }
      ... on Image {
        ...BaseImageFragment
      }
      ... on SectionPanel {
        ...BaseSectionPanelFragment
      }
      ... on Video {
        ...BaseVideoFragment
      }
    }
  }
`;
